<mat-icon
  fontSet="material-symbols-outlined"
  [style.width]="size + 'px'"
  [style.height]="size + 'px'"
  [style.font-size]="size + 'px'"
  ><ng-content></ng-content
></mat-icon>
